module.exports = __webpack_public_path__ + "static/media/google_reviews.7e5d6aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/google_reviews.png
// module id = 165
// module chunks = 0